export class HugoModuleMapConfig {
    public map_branches: number[]
    // Additional dynamic HugoModuleLatestVehiclesSliderConfigMode fields can be added (TS won't know about them but they will be there)
    // If you know the settings will be used across multiple templates, it would be better to add the setting here and add it to the "config.toml" file in this module but don't worry too much - you can always add it later
}